module.exports = __webpack_public_path__ + "img/nanyida_result01.0eab4828.png";